var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"button",class:[_vm.variant, _vm.color, _vm.size],on:{"click":_vm.onClick}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }